// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel-module--carousel--vUO9o","item":"Carousel-module--item--BdgPi"};